import React, { useState, useContext } from 'react';

const SeriesOfArticlesContext = React.createContext();

const SeriesOfArticlesProvider = ({ children, value = {} }) => {
  const [nextLink, setNextLink] = useState(value?.nextLink);
  const [previousLink, setPreviousLink] = useState(value?.previousLink);

  const context = {
    nextLink,
    setNextLink,
    previousLink,
    setPreviousLink,
  };

  return (
    <SeriesOfArticlesContext.Provider value={context}>
      {children}
    </SeriesOfArticlesContext.Provider>
  );
};

const useSeriesOfArticles = () => {
  return useContext(SeriesOfArticlesContext);
};

export default useSeriesOfArticles;

export { SeriesOfArticlesProvider };
